import { render, staticRenderFns } from "./EnlaceRecibo.vue?vue&type=template&id=1a3f1f10&scoped=true&"
import script from "./EnlaceRecibo.vue?vue&type=script&lang=js&"
export * from "./EnlaceRecibo.vue?vue&type=script&lang=js&"
import style0 from "./EnlaceRecibo.vue?vue&type=style&index=0&id=1a3f1f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f1f10",
  null
  
)

export default component.exports